<form [formGroup]="form">
  <div>
    <div>
      <h2 class="row">{{''|i18n:'settings-on-saving'}}</h2>
      <table class="table-header">
        <thead>
          <tr>
            <th>{{''|i18n:'order-date-date-in-the-past'}}</th>
            <th>{{''|i18n:'order-date-in-the-future'}}</th>
            <th>{{''|i18n:'delivery-date-in-the-past'}}</th>
            <th>{{''|i18n:'delivery-date-in-the-future'}}</th>
            @if (showNLFields) {
              <th>{{''|i18n:'delivery-date-in-the-future-minimum'}}</th>
            }
          </tr>
        </thead>
      </table>
      <div class="row">
        <div class="col-md"><input type="number" formControlName="savingOrderDateMaxNumberOfDaysInThePast"></div>
        <div class="col-md"><input type="number" formControlName="savingOrderDateMaxNumberOfDaysInTheFuture"></div>
        <div class="col-md"><input type="number" formControlName="savingDeliveryDateMaxNumberOfDaysInThePast"></div>
        <div class="col-md"><input type="number" formControlName="savingDeliveryDateMaxNumberOfDaysInTheFuture"></div>
        @if (showNLFields) {
          <div class="col-md"><input type="number" formControlName="savingDeliveryDateMinNumberOfDaysInTheFuture"></div>
        }
      </div>
      <hr/>
    </div>

    <h2 class="row">{{''|i18n:'settings-on-submission'}}</h2>
    <table class="table-header">
      <thead>
        <tr>
          <th>{{''|i18n:'order-date-date-in-the-past'}}</th>
          <th>{{''|i18n:'order-date-in-the-future'}}</th>
          <th>{{''|i18n:'delivery-date-in-the-past'}}</th>
          <th>{{''|i18n:'delivery-date-in-the-future'}}</th>
          @if (showNLFields) {
            <th>{{''|i18n:'delivery-date-in-the-future-minimum'}}</th>
          }
        </tr>

      </thead>
    </table>
    <div class="row">
      <span class="col-md"><input type="number" formControlName="submissionOrderDateMaxNumberOfDaysInThePast"></span>
      <span class="col-md"><input type="number" formControlName="submissionOrderDateMaxNumberOfDaysInTheFuture"></span>
      <span class="col-md"><input type="number" formControlName="submissionDeliveryDateMaxNumberOfDaysInThePast"></span>
      <span class="col-md"><input type="number" formControlName="submissionDeliveryDateMaxNumberOfDaysInTheFuture"></span>
      @if (showNLFields) {
        <span class="col-md"><input type="number" formControlName="submissionDeliveryDateMinNumberOfDaysInTheFuture"></span>
      }
    </div>
    <hr/>
  </div>
  <div class="vertical-line"></div>
  <div class="row">
    <div class="col-3"></div>
    <div class="col-3"></div>
    <div class="col-3"></div>
    @if (showNLFields) {
      <div class="col-3"></div>
    }
    <div class="col-3">
      <button class="col-9" [disabled]="!formValid()" (click)="save()">{{''|i18n:'save-changes'}}</button>
    </div>
  </div>
</form>
